export const environment = {
    LOCALHOST_URL:"https://gtt.onrender.com"
    // LOCALHOST_URL:"https://gtt.onrender.com"
    // LOCALHOST_URL:"http://localhost:5005"
}
